// src/services/emailConfirmationDataService.js
import { Capacitor } from "@capacitor/core";
import { FirebaseAuthentication } from "@capacitor-firebase/authentication";
import { sendEmailVerification as webSendEmailVerification } from "firebase/auth";

import { auth } from "../firebase";
import {
  getCurrentAuthUser,
  reloadCurrentAuthUser,
} from "./authDataService";

export const getCurrentEmailConfirmationUserData = async () => {
  try {
    const user = await getCurrentAuthUser();
    return user || null;
  } catch (error) {
    console.warn("getCurrentEmailConfirmationUserData failed:", error);
    return null;
  }
};

const isNative = () => {
  try {
    const p = Capacitor.getPlatform();
    return p === "ios" || p === "android";
  } catch {
    return false;
  }
};

export const resendVerificationEmailData = async () => {
  if (isNative()) {
    await FirebaseAuthentication.sendEmailVerification();
    return { ok: true };
  }

  const currentAuthUser = auth?.currentUser || null;

  if (!currentAuthUser) {
    throw new Error("no-current-user");
  }

  await webSendEmailVerification(currentAuthUser);
  return { ok: true };
};

export const reloadEmailVerificationStateData = async () => {
  try {
    const reloadedUser = await reloadCurrentAuthUser();

    if (reloadedUser) {
      return {
        ok: true,
        user: reloadedUser,
        emailVerified: !!reloadedUser.emailVerified,
      };
    }
  } catch (error) {
    console.warn("reloadCurrentAuthUser failed:", error);
  }

  const currentAuthUser = auth?.currentUser || null;

  if (!currentAuthUser) {
    return {
      ok: false,
      user: null,
      emailVerified: false,
      reason: "no-current-user",
    };
  }

  await reloadCurrentAuthUser();

  return {
    ok: true,
    user: {
      uid: currentAuthUser.uid,
      email: currentAuthUser.email || "",
      displayName: currentAuthUser.displayName || "",
      emailVerified: !!currentAuthUser.emailVerified,
      isAnonymous: !!currentAuthUser.isAnonymous,
      providerId: currentAuthUser.providerData?.[0]?.providerId || null,
    },
    emailVerified: !!currentAuthUser.emailVerified,
  };
};